const FIELD_TYPES = {
  TEXT: 'text',
  PASSWORD: 'password',
  DATE: 'date',
}

export default FIELD_TYPES
